export default {
  email: [
    { required: true, message: 'Email is required.' },
    { type: 'email', message: 'Email is invalid' }
  ],
  password: [{ required: true, message: 'Password is required.' }]
}
